import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'

import { CmsJobOffer } from 'types/cms/collection-types'

/**
 * Get the job offers from the CMS
 *
 * @param {'all' | Language} locale
 * @returns {Promise<CmsJobOffer[]>}
 */
const getJobOffers = async (locale: 'all' | Language = Language.DUTCH): Promise<CmsJobOffer[]> => {
  try {
    const { data } = await axios.get<CMSApiResponseBody<CmsJobOffer[]>>(`${process.env.CMS_API_URL}/job-offers?locale=${locale}`)

    return data.data
  } catch (_) {
    return []
  }
}

export default getJobOffers
